import {
  BackgroundColors,
  TextColors,
  PremiumColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { isLeftToRight, isRightToLeft } from '@picsart/design-system/foundation/styleHelpers';
import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  () => ({
    root: {
      position: 'relative',
      marginBottom: Spacings.s48,
      padding: [100, Spacings.s0],
      backgroundColor: BackgroundColors.tint1,

      [mediaQuery(BreakPoints.Large)]: {
        padding: [100, Spacings.s64],
      },
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [100, Spacings.s32],
      },
    },
    wrapper: {
      display: 'block',
      fontWeight: FontWeights.semibold,
      maxWidth: 1320,
      margin: [Spacings.s0, 'auto'],
      color: TextColors.tint1,

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        maxWidth: 456,
      },
    },
    list: {
      position: 'relative',
    },

    title: {
      marginBottom: Spacings.s40,
      lineHeight: LineHeights.l36,
      fontSize: FontSizes.s30,

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        lineHeight: LineHeights.l32,
        fontSize: FontSizes.s24,
      },
    },
    listItem: {
      display: 'grid',
      gridTemplateColumns: '32px 1fr',
      gap: Spacings.s24,
      listStyle: 'none',
      marginBottom: Spacings.s32,
      lineHeight: LineHeights.l32,
      fontSize: FontSizes.s24,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginBottom: Spacings.s24,
        gap: Spacings.s16,
        lineHeight: LineHeights.l24,
        fontSize: FontSizes.s16,
      },
    },
    icon: {
      position: 'relative',
      top: Spacings.s0,
      fill: PremiumColors.base.default,

      [isLeftToRight]: {
        left: Spacings.s0,
      },
      [isRightToLeft]: {
        right: Spacings.s0,
      },
    },
    itemFallback: {
      height: 32,
      marginBottom: Spacings.s16,
    },
    titleFallback: {
      width: 200,
      height: 42,
      marginBottom: Spacings.s40,
    },
  }),
  {
    name: 'benefits-list',
  },
);

export default useStyles;
